import testimonialDummy from '@/assets/images/icons/testimonial_dummy.png';

export const testimonials = [
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Archana Singh',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Singh',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Archana',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Archana Singh',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Archana Singh',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Archana Singh',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
  {
    description: "If you're not regularly asking your customers for reviews.",
    userImage: testimonialDummy,
    userName: 'Archana Singh',
    userDesignation: 'Corporate Professional',
    userPlace: 'Bangalore',
  },
];
